import {CREATE_CARTRULE_ERROR, CREATE_CARTRULE_REQUESTED} from './create.actions';
import { Component, OnInit } from '@angular/core';
import store from './../../../store/store.module';
import {GET_ALL_CARTRULE_MENU_REQUESTED, GET_CARTRULE_TEMPLATE_REQUESTED} from "../cartrule.action";
import * as moment from 'moment';
import * as _ from 'lodash';
import {FETCH_CONSTANTS_REQUESTED} from "../../../store/constant/list/list.actions";
import {UtilityService} from "../../../common/services/utility/utility.service";

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent implements OnInit {
  public static defaultCondition = {
    type: 'combine',
    attribute: null,
    operator: null,
    value: '1',
    is_value_processed: null,
    aggregator: 'all'
  };
  public static defaultActionToCondition = {
    type: 'product_combine',
    attribute: null,
    operator: null,
    value: '1',
    is_value_processed: null,
    aggregator: 'all'
  };
  public static defaultCartRule = {
    name: '',
    description: '',
    valid_from: moment(),
    valid_to: moment().add(1),
    is_active: true,
    condition: CreateComponent.defaultCondition,
    action_to_condition: CreateComponent.defaultActionToCondition,
    action: '',
    free_shipping_condition: '',
    include_discount_to_shipping_fee: false,
    discount_amount: 0,
    max_discount_qty: null,
    discount_step: null,
    coupon_prefix: ''
  };
  public static defaultCoupon = {
    code: '',
    usage_limit: 1,
    usage_per_customer: 1,
    valid_from: moment(),
    valid_to: moment().add(1),
    is_active: true
  };
  public static originalCartrule = {
    pattern: '',
    data: CreateComponent.defaultCartRule
  };
  public store = store;
  public utilityService;
  public redirectData;
  public cartrule = {
    ...CreateComponent.originalCartrule
  };
  public coupons = [];
  public mainCondition;
  public mainAction;

  constructor(utilityService: UtilityService) {
    this.utilityService = utilityService;
  }

  ngOnInit() {
    this.redirectData = this.utilityService.getRedirectData();
    store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });
    store.dispatch({ type: GET_CARTRULE_TEMPLATE_REQUESTED });
    store.dispatch({ type: GET_ALL_CARTRULE_MENU_REQUESTED });
    store.subscribe(() => {
      if (store.getState().Cartrule.allMenu.fetched) {
        this.mainCondition = store.getState().Cartrule.allMenu.item.conditions.find(s => s.main === true);
        this.mainAction = store.getState().Cartrule.allMenu.item.actions.find(s => s.main === true);
      }
    });
    this.coupons.push({
      key: this.generateRandomCouponId(),
      ...CreateComponent.defaultCoupon
    });
  }

  onSubmit(form) {
    if (form.valid) {
      if (_.uniqBy(this.coupons, 'code').length !== this.coupons.length) {
        store.dispatch({ type: CREATE_CARTRULE_ERROR, message: 'Coupon should be unique' });
        return;
      }
      let req = {
        ..._.omit(this.cartrule.data, ['coupon_prefix']),
        coupons: [
          ...this.coupons.map(s => {
            let prefix = this.cartrule.data['coupon_prefix'] ? this.cartrule.data['coupon_prefix'] : '';
            return {
              ..._.omit(s, ['key', 'code']),
              code: prefix + (s.code ? s.code : '')
            };
          })
        ]
      };
      store.dispatch({ type: CREATE_CARTRULE_REQUESTED, data: req });
    }
  }

  changePattern(pattern) {
    if (!pattern) {
      this.cartrule = {
        ...CreateComponent.originalCartrule
      };
      return;
    }
    this.cartrule.pattern = pattern.id;
    this.cartrule.data = {
      ...JSON.parse(
        JSON.stringify(
          _.omit(
            _.pick(pattern, Object.keys(CreateComponent.defaultCartRule)),
            ['valid_from', 'valid_to', 'is_active']
          )
        )
      ),
      valid_from: moment(),
      valid_to: moment().add(1),
      is_active: true
    };
  }
  updateCondition(val) {
    this.cartrule.data.condition = val;
  }
  updateActionCondition(val) {
    this.cartrule.data.action_to_condition = val;
  }
  removeCoupon(key) {
    this.coupons = this.coupons.filter(s => s.key !== key);
  }
  addCoupon() {
    this.coupons.push({
      key: this.generateRandomCouponId(),
      ...CreateComponent.defaultCoupon
    });
  }
  generateRandomCouponId() {
    return Math.random().toString(36).substring(7);
  }
  couponTracker(index, item) {
    return item.key;
  }
}
